(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["km-barra-carrito"] && !Shopify.designMode) return;
  try {
    
(function () {
  function dinero(centavos) {
    var n = centavos / 100;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: centavos % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function escribir(nodo, plantilla, monto) {
    nodo.textContent = '';
    var partes = plantilla.split('[monto]');
    nodo.appendChild(document.createTextNode(partes[0]));
    if (partes.length > 1) {
      var fuerte = document.createElement('strong');
      fuerte.textContent = monto;
      nodo.appendChild(fuerte);
      nodo.appendChild(document.createTextNode(partes.slice(1).join('')));
    }
  }

  function iniciar(barra) {
    if (barra.dataset.kmListo) return;
    barra.dataset.kmListo = '1';
    var d = barra.dataset;
    var minimo = Number(d.minimo);
    var gratis = Number(d.gratis);
    var envio = Number(d.envio);
    var msg = barra.querySelector('[data-km-barra-msg]');
    var total = barra.querySelector('[data-km-barra-total]');
    var avance = barra.querySelector('[data-km-barra-avance]');
    var btn = barra.querySelector('[data-km-barra-btn]');

    function pintar(centavos, cantidad) {
      barra.hidden = !cantidad;
      if (!cantidad) {
        document.body.style.paddingBottom = '';
        return;
      }
      total.textContent = dinero(centavos);
      avance.style.width = Math.min(100, (centavos / gratis) * 100) + '%';
      barra.classList.toggle('is-minimo', centavos >= minimo);
      barra.classList.toggle('is-gratis', centavos >= gratis);
      if (centavos < minimo) {
        escribir(msg, d.txtMinimo, dinero(minimo - centavos));
        btn.textContent = d.btnSeguir;
        btn.setAttribute('href', d.hrefSeguir);
      } else if (centavos < gratis) {
        escribir(msg, d.txtGratis, dinero(gratis - centavos));
        btn.textContent = d.btnPagar + ' · ' + dinero(centavos) + ' + ' + dinero(envio) + ' ' + d.txtEnvio;
        btn.setAttribute('href', d.hrefPagar);
      } else {
        escribir(msg, d.txtListo, '');
        btn.textContent = d.btnPagar + ' · ' + dinero(centavos);
        btn.setAttribute('href', d.hrefPagar);
      }
      document.body.style.paddingBottom = barra.offsetHeight + 'px';
    }

    function consultar() {
      fetch(d.cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { pintar(c.total_price, c.item_count); })
        .catch(function () {});
    }

    pintar(Number(d.total), Number(d.cantidad));
    document.addEventListener('km:carrito', consultar);
    window.addEventListener('pageshow', consultar);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) consultar();
    });
    document.addEventListener('submit', function (e) {
      var accion = (e.target.getAttribute && e.target.getAttribute('action')) || '';
      if (accion.indexOf('/cart') !== -1) setTimeout(consultar, 1500);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-items-component, cart-drawer-component, add-to-cart-component, [name="add"]')) setTimeout(consultar, 1500);
    }, true);
  }

  function todas() {
    document.querySelectorAll('[data-km-barra]').forEach(iniciar);
  }
  todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["km-entregas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.kmListo) return;
    raiz.dataset.kmListo = '1';
    var form = raiz.querySelector('[data-km-zona]');
    if (!form) return;
    var msg = form.querySelector('[data-km-zona-msg]');
    var dias = Array.prototype.slice.call(raiz.querySelectorAll('[data-km-dia]'));

    function decir(texto) {
      msg.textContent = texto;
      msg.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cp = (form.elements.cp.value || '').replace(/\D/g, '');
      dias.forEach(function (d) { d.classList.remove('is-tuyo'); });
      if (cp.length !== 5) {
        decir(raiz.dataset.msgInvalido);
        return;
      }
      var encontrado = null;
      dias.forEach(function (d) {
        if (encontrado) return;
        var lista = (d.dataset.cps || '').split(',');
        if (lista.indexOf(cp) !== -1) encontrado = d;
      });
      if (!encontrado) {
        decir(raiz.dataset.msgFuera);
        return;
      }
      var dia = encontrado.dataset.kmDia;
      encontrado.classList.add('is-tuyo');
      decir(raiz.dataset.msgOk.replace('[dia]', dia));
      fetch(raiz.dataset.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Día de entrega': dia, 'Código postal': cp } })
      }).catch(function () {});
    });
  }

  function todos() {
    document.querySelectorAll('[data-km-entregas]').forEach(iniciar);
  }
  todos();
  document.addEventListener('shopify:section:load', todos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["km-sabores"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.kmListo) return;
    raiz.dataset.kmListo = '1';
    var grid = raiz.querySelector('[data-km-grid]');
    var aviso = raiz.querySelector('[data-km-aviso]');
    if (!grid) return;

    function sincronizar() {
      var f = grid.dataset.formato;
      raiz.querySelectorAll('[data-km-add]').forEach(function (b) {
        b.disabled = !b.dataset['v' + f];
      });
    }

    raiz.querySelectorAll('[data-km-formato]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grid.dataset.formato = btn.dataset.kmFormato;
        raiz.querySelectorAll('[data-km-formato]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        sincronizar();
      });
    });

    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-km-add]');
      if (!b || b.disabled) return;
      var id = b.dataset['v' + grid.dataset.formato];
      if (!id) return;
      b.disabled = true;
      fetch(raiz.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('carrito');
          return r.json();
        })
        .then(function () {
          b.classList.add('is-ok');
          if (aviso) aviso.textContent = b.dataset.nombre + ' se agregó a tu pedido.';
          document.dispatchEvent(new CustomEvent('km:carrito'));
          setTimeout(function () { b.classList.remove('is-ok'); }, 1200);
        })
        .catch(function () {
          if (aviso) aviso.textContent = 'No pudimos agregarlo. Intenta de nuevo.';
        })
        .finally(function () {
          b.disabled = false;
        });
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-km-elegir]');
      if (!a) return;
      var btn = raiz.querySelector('[data-km-formato="' + a.dataset.kmElegir + '"]');
      if (btn) btn.click();
    });

    sincronizar();
  }

  function todos() {
    document.querySelectorAll('[data-km-sabores]').forEach(iniciar);
  }
  todos();
  document.addEventListener('shopify:section:load', todos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
